/* eslint-disable react/prop-types */
import React from 'react';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { Row, Col,Tabs,Divider} from 'antd';
// import {Tabs } from 'antd';
// const { TabPane } = Tabs;
const titles =["模块化设计","院系深度参与","5G学习与就业解决方案","线上线下活动相结合","兼顾就业、实习与兼职","以学习带动就业","AI","就业安全"]
import { getChildrenToRender } from './utils';
const { TabPane } = Tabs;
function Feature9(props) {
  const { dataSource, isMobile, ...tagProps } = props;
  const { blockWrapper, titleWrapper } = dataSource;
  const childrenToRender = blockWrapper.children.map((item, i) => (
    <TabPane {...item} key={i.toString()} tab={<div style={{height:'30px',marginTop:'15px'}}>{titles[i]}</div>}>
      <a {...item.children}>
        {item.children.children.map(getChildrenToRender)}
      </a>
    </TabPane>
  ));

  return (
    <div {...tagProps} {...dataSource.wrapper}>
      <div {...dataSource.page}>
        <div {...dataSource.titleWrapper}>
          {titleWrapper.children.map(getChildrenToRender)}
        </div>
        <OverPack {...dataSource.OverPack}>
          <Row gutter={24} style={{height:'50px',backgroundColor:'#108ee9',marginBottom:'8px',marginLeft:'4px',marginRight:'38px'}}>
             <Col span={5} style={{marginTop:'10px',color:'#f7f9fc',textAlign:'center'}}>优势</Col>
             <Col span={1} style={{marginTop:'10px',color:'#f7f9fc',textAlign:'center'}}>
             <Divider type="vertical" />
             </Col>
             <Col span={12} style={{marginTop:'10px',color:'#f7f9fc',textAlign:'center'}}>详情</Col>
          </Row>
          <QueueAnim
            key="queue"
            type="bottom"
            leaveReverse
            interval={50}
            component={Row}
            {...blockWrapper}
          >

            
            <Tabs tabPosition='left' type="card" tabBarGutter={1} size='large'>
            {childrenToRender}
            </Tabs>
       
          </QueueAnim>
        </OverPack>
      </div>
    </div>
  );
}

export default Feature9;